import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDBodyText,
  FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { PXFormModalWrapper } from 'Views/Page/Content/Modal/Layouts/PXFormModalWrapper';
import { FormSection } from 'Components/ComponentLibrary/Molecules/FormSection';
import { FDInputRow } from 'Packages/FacetDesign/Components/Experimental/fdInputRow';

const Layout = () => {
  const { resource } = useMetaLayoutContext();

  const primaryGrossAnnualIncome = resource.attr('primaryGrossAnnualIncome') ? parseFloat(resource.attr('primaryGrossAnnualIncome')) : 0;
  const primaryAnnualPayPeriods = resource.attr('primaryAnnualPayPeriods') ? parseFloat(resource.attr('primaryAnnualPayPeriods')) : 0;
  const totalPayPerPeriod = primaryGrossAnnualIncome / primaryAnnualPayPeriods;
  const preTaxESPContribution = resource.attr('preTaxContributionEsp') ? parseFloat(resource.attr('preTaxContributionEsp')) : 0;
  const postTaxESPContribution = resource.attr('postTaxContributionEsp') ? parseFloat(resource.attr('postTaxContributionEsp')) : 0;
  const totalESPContribution = preTaxESPContribution + postTaxESPContribution;
  const currentESPPercent = `${(100 * totalESPContribution / totalPayPerPeriod).toFixed(0)}`;

  return (
    <PXFormModalWrapper>
      <FDStack direction={'column'} spacing={2}>
        {resource.isTruthy('hasElectiveESPMatching') ? (
          <FDStack direction={'column'}>
            <FDInputRow>
              <MetaControlField
                attr="preTaxContributionEsp"
                flex={1}
                CustomProps={{
                  helperTextValue: 'e.g. your 401k contribution',
                }}
              />
              <MetaControlField
                attr="postTaxContributionEsp"
                flex={1}
                CustomProps={{
                  helperTextValue: 'e.g. your Roth 401k contribution',
                }}
              />
              <div style={{ flex: 1 }} />
            </FDInputRow>
            {totalPayPerPeriod > 0 ? (
              <FDBodyText value={<p>This is roughly a <b>{`${currentESPPercent}%`}</b> match based on your primary income.</p>} />
            ) : null}
          </FDStack>
        ) : null}
        <FormSection title={'Insurance Deductions'}>
          <FDInputRow>
            <MetaControlField attr="medicalContribution" flex={1} />
            <MetaControlField attr="visionContribution" flex={1} />
            <MetaControlField attr="hsaContribution" flex={1} />
            <MetaControlField attr="fsaContribution" flex={1} />
            <MetaControlField attr="dentalContribution" flex={1} />
          </FDInputRow>
        </FormSection>
        <FormSection title={'Besides taxes, is there anything else taken out of your paycheck?'}>
          <FDInputRow>
            <MetaControlField
              attr="preTaxOtherContribution"
              flex={1}
              CustomProps={{
                helperTextValue: 'All other pre-tax deductions',
              }}
            />
            <MetaControlField
              attr="postTaxOtherContribution"
              flex={1}
              CustomProps={{
                helperTextValue: 'All other post-tax deductions',
              }}
            />
          </FDInputRow>
        </FormSection>
      </FDStack>
    </PXFormModalWrapper>
  );
};

export default Layout;
